import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import {
  // Link,
  Container,
  Typography,
  Paper,
  // Divider,
  // Stack,
  // Button
} from '@mui/material';
// hooks
import useResponsive from 'hooks/useResponsive';
// components
import Logo from 'components/logo';
// import Iconify from 'components/iconify';
// sections
import { LoginForm } from 'sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
const StyledLogo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(2, 2.5),
  marginBottom: window.screen.height * 0.2,
  width: '100%',
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Login | Alu Jaya </title>
      </Helmet>

      <StyledRoot>
        {mdUp && (
          <StyledSection>
            <StyledLogo>
              <Logo />
            </StyledLogo>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5, justifyContent: 'center' }}>
              Hi, Selamat Datang
            </Typography>
            <img src="/assets/illustrations/illustration_login.png" alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <StyledContent>
            <Paper sx={{ padding: 5 }} elevation={6}>
              <Typography sx={{ mb: 3 }} variant="h4" gutterBottom>
                Masuk ke Alu Jaya
              </Typography>
              <LoginForm />
            </Paper>
          </StyledContent>
        </Container>
      </StyledRoot>
      {/*
        <Typography variant="body2" sx={{ mb: 5 }}>
        Don’t have an account? {''}
        <Link variant="subtitle2">Get started</Link>
        </Typography> 
      */}

      {/* 
        <Stack direction="row" spacing={2}>
        <Button fullWidth size="large" color="inherit" variant="outlined">
        <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />
        </Button>
        <Button fullWidth size="large" color="inherit" variant="outlined">
        <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />
        </Button>
        <Button fullWidth size="large" color="inherit" variant="outlined">
        <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />
        </Button>
        </Stack>
        <Divider sx={{ my: 3 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        OR
        </Typography>
        </Divider> 
      */}
    </>
  );
}
